module.exports = __webpack_public_path__ + "static/media/hire-password.6a6d290d.svg";